import React, { useCallback, useState } from "react";
import { ReactFlow, useReactFlow, Controls, applyEdgeChanges, addEdge, applyNodeChanges } from "@xyflow/react";
import StartNode from "./nodes/StartNode";
import '@xyflow/react/dist/style.css';
import ActionNode from "./nodes/ActionNode";
import RemovableEdge from "./edges/RemovableEdge";
import ConditionNode from "./nodes/ConditionNode";
import NodeModal from "./modal/NodeModal";
import { InputCheckbox } from "../checkbox/InputCheckbox";
import { TriggerSessionModal } from "../../components/triggers/utils/TriggerSessionModal";

const rfStyle = {
  backgroundColor: "#B8CEFF"
};

const edgeOptions = {
  type: "removableEdge",
  //animated: true
};

const edgeTypes = {
  removableEdge: RemovableEdge
};

const nodeTypes = {
  StartNode: StartNode,
  ConditionNode: ConditionNode,
  ActionNode: ActionNode
};

const nodeTitles = {
  StartNode: "Старт",
  ConditionNode: "Условие",
  ActionNode: "Действие"
};

export const Flow = ({nodesInit, edgesInit, onSave, active, onActiveChange, flowId}) => {
  const reactFlowInstance = useReactFlow();

  const [nodes, setNodes] = useState(nodesInit || []);
  const [edges, setEdges] = useState(edgesInit || []);
  const blockNames = nodesInit?.reduce((acc, i) => ({...acc, [i.id]: nodeTitles[i.type] + ": " + (i.data?.value || '') }), {});

  const addNewNode = (node) => {
    reactFlowInstance.addNodes(node);
    setNodes(reactFlowInstance.getNodes());
    setEdges(reactFlowInstance.getEdges());
  };

  const save = () => {
    onSave(reactFlowInstance.getNodes(), reactFlowInstance.getEdges());
  };

  const onNodesChange = useCallback(
    (changes) => setNodes((nds) => applyNodeChanges(changes, nds)),
    [setNodes],
  );

  const onEdgesChange = useCallback(
    (changes) => setEdges((eds) => applyEdgeChanges(changes, eds)),
    [setEdges],
  );
  const onConnect = useCallback(
    (connection) => setEdges((eds) => addEdge(connection, eds)),
    [setEdges],
  );

  return (
    <>
      <div style={{display: "flex", alignItems: "center", gap: "10px", marginBottom: "5px"}}>
        
        {!active && <NodeModal handleOk={addNewNode} triggerWrap={false} trigger={<button className="btn">Добавить блок</button>} />}
        {active && <button className="btn" disabled={true} style={{opacity: 0.7}}>Добавить блок</button>}
        <button className="btn btn-red" onClick={save} disabled={nodes.length === 0 || active}>Сохранить процесс</button>
        <InputCheckbox title="Процесс активен" name="active" checked={active} disabled={onActiveChange === null} onChange={onActiveChange}/>
        <TriggerSessionModal trigger={<button className="btn">История запусков</button>} flowId={flowId} blockNames={blockNames}/>
      </div>
      <div style={{height: '80vh'}} className={active && false ? "flow-readonly" : ""}>
      <ReactFlow
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        nodesConnectable={!active}
        onConnect={onConnect}
        nodeTypes={nodeTypes}
        edgeTypes={edgeTypes}
        defaultEdgeOptions={edgeOptions}
        nodes={nodes}
        edges={edges}
        //fitView
        style={rfStyle}
      >
        <Controls />
      </ReactFlow>
      </div>
    </>
  );
};
